import { WizCommand } from '@wizeoo/akm-component-lib';
import { DataLoadObj } from '@wizeoo/akm-compute-lib';
import { BaselineCriteria, DataMetrics } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/** compte le nombre de baselines pour un FEI */
export class CountDataCommand extends WizCommand<DataMetrics> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  public dataLoad: DataLoadObj; // la conf d'appel

  /**
   * collecte du nombre de BL, BLV et maxNumRev pour le DLO
   */
  public count(dataLoad: DataLoadObj, callback: Function): CountDataCommand {
    
    this.dataLoad = dataLoad;

    const criteria: BaselineCriteria = new BaselineCriteria();

    criteria.domain = dataLoad.visionStep.domain;
    criteria.businessUnitCode = dataLoad.visionStep.businessUnitCode;
    criteria.visionCode = dataLoad.visionStep.visionCode;
    criteria.chronoCode = dataLoad.visionStep.chronoCode;
    criteria.scenarioCode = dataLoad.scenario;
    criteria.level = dataLoad.visionStep.level;
    criteria.revisionNumber = dataLoad.revisionNumber;

    // console.log('count', dataLoad, dataLoad.visionStep.level, dataLoad.scenario, dataLoad.revisionNumber);
    this.configureRemote(ExternalAPI.DATA_COUNT_API, criteria, callback);
    return this;
  }

  wizResult() {
    super.wizResult();
    try {
      this.dataLoad.state = DataLoadObj.LOADING;
      this.dataLoad.nbLines = this.result.nbLines;
      this.dataLoad.nbValues = this.result.nbValues;
      this.dataLoad.remoteRevisionNumber = this.result.numRev;
      // console.log('count', this.dataLoad);
    } catch(e: any) {
      console.log('count error', this);
    }
  }

}
